import React from 'react';
import Slider from "react-slick";
import SlideBg from "../../../../images/login-img.jpg";
import ShadeIcon from "../../../../images/icon-shade.svg"
import LoginIcon from "../../../../images/login-icon.png";
import LoginIcon2 from "../../../../images/sign-up-icon.png";
import LoginIcon3 from "../../../../images/passcode-icon.png";
import LoginIcon4 from "../../../../images/password-icon.png";
import { motion } from 'framer-motion';

const LoginSlider = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
  };

  // Animation variants per slide
  const animations = [
    {
      image: {
        hidden: { opacity: 0, x: -50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
      },
      content: {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.3 } },
      },
    },
    {
      image: {
        hidden: { opacity: 0, scale: 0.8 },
        visible: { opacity: 1, scale: 1, transition: { duration: 0.7 } },
      },
      content: {
        hidden: { opacity: 0, x: -30 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.3 } },
      },
    },
    {
      image: {
        hidden: { opacity: 0, rotate: -10 },
        visible: { opacity: 1, rotate: 0, transition: { duration: 0.7 } },
      },
      content: {
        hidden: { opacity: 0, scale: 0.9 },
        visible: { opacity: 1, scale: 1, transition: { duration: 0.5, delay: 0.3 } },
      },
    },
    {
      image: {
        hidden: { opacity: 0, y: -40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
      },
      content: {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.3 } },
      },
    },
  ];

  const slideData = [
    {
      img: LoginIcon,
      heading: "A touch of heaven in every gift",
      text: "Contrary to popular belief, Lorem Ipsum is not simply random text...",
    },
    {
      img: LoginIcon2,
      heading: "A gift of love, a blessing from above",
      text: "Contrary to popular belief, Lorem Ipsum is not simply random text...",
    },
    {
      img: LoginIcon3,
      heading: "Because every gift is a blessing",
      text: "Contrary to popular belief, Lorem Ipsum is not simply random text...",
    },
    {
      img: LoginIcon4,
      heading: "Giving with heart, receiving with grace.",
      text: "Contrary to popular belief, Lorem Ipsum is not simply random text...",
    },
  ];

  return (
    <>
      <div className='slide-bg'>
        <figure>
          <img src={SlideBg} alt='Background' />
        </figure>
      </div>

      <div className='slide-block'>
        <Slider {...sliderSettings}>
          {slideData.map((slide, index) => {
            const animation = animations[index % animations.length];

            return (
              <div className='slide_grid' key={index}>
                <div className='mbl-cont'>
                  <motion.h2
                    initial="hidden"
                    animate="visible"
                    variants={animation.content}
                  >
                    {slide.heading}
                  </motion.h2>
                  <motion.p
                    initial="hidden"
                    animate="visible"
                    variants={animation.content}
                  >
                    {slide.text}
                  </motion.p>
                </div>
                <figure className='slide-img'>
                  <motion.img
                    src={slide.img}
                    alt={`Slide ${index + 1}`}
                    initial="hidden"
                    animate="visible"
                    variants={animation.image}
                  />
                  <img className='slide-bg-shade' src={ShadeIcon} alt='' />
                </figure>
                <div className='desk-cont'>
                  <motion.h2
                    initial="hidden"
                    animate="visible"
                    variants={animation.content}
                  >
                    {slide.heading}
                  </motion.h2>
                  <motion.p
                    initial="hidden"
                    animate="visible"
                    variants={animation.content}
                  >
                    {slide.text}
                  </motion.p>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </>
  );
};

export default LoginSlider;
